// LIBRARIES //
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router';

// COMPONENTS //
import EmploymentInformation from './components/review_applicants/EmploymentInformation.js';
import ApplicantQuestions from './components/review_applicants/ApplicantQuestions.js';
import ApplicantPreviousAddress from './components/review_applicants/ApplicantPreviousAddress';
import LandlordReference from './components/review_applicants/LandlordReference.js';
import PersonalReference from './components/review_applicants/PersonalReference.js';
import EmergencyContact from './components/review_applicants/EmergencyContact';
import ChargeCardDialog from './components/review_applicants/ChargeCardDialog';
import TenantVehicles from './components/review_applicants/VehicleDetails.js';
import TenantInfo from './components/review_applicants/TenantInfo.js';
import TenantPets from './components/review_applicants/PetDetails.js';
import AdditionalOccupants from './components/review_applicants/AdditionalOccupants.js';
import ReviewTerms from './components/review_applicants/ReviewTerms.js';
import PrintButton from 'components/shared/PrintButton';
import FlatButton from 'material-ui/FlatButton';
import Paper from 'material-ui/Paper';

// ACTIONS //
import * as landlordApplications from 'actions/landlordApplicationsActions';
import { showFailure } from 'actions/notificationActions';

// HELPERS //
import { AccentColor } from 'helpers/AccentColorHelper';

// STYLE //
import './components/review_applicants/AppPage.css';
import './components/review_applicants/ReviewApplicants.css';

export default connect(
  store => {
    const targetApplication = store.landlordApplications.application;
    return {
      additionalOccupants: targetApplication.additional_occupants || [],
      applicantData: targetApplication.cotenants || [],
      leaseDetails: store.landlordApplications.leaseDetails,
      showPage: store.authentication.showPage,
      applicationID: store.landlordApplications.applicationId,
      application: store.landlordApplications.application,
      landlordCountry: store.userTypes.landlordCountry,
    };
  },
  {
    showFailure,
    ...landlordApplications,
  }
)(
  class ReviewApplicants extends Component {
    constructor(props) {
      super(props);
      this.state = {
        numberOfApplicants: 0,
        currentApplicant: 0,
        creatingLease: false,
        showChargeCard: false,
        submitting: false,
      };
    }

    approveReference = async (applicantId, referenceType, referenceUuid) => {
      await this.props.approveReference(applicantId, referenceType, referenceUuid);
      this.props.getApplication(this.props.applicationID);
      this.props.getLease(this.props.leaseDetails.lease_id);
    };

    componentDidMount() {
      this.props.getApplication(this.props.applicationID).then(() => {
        this.setState({
          currentApplicant: this.props.applicantData.length > 0 ? 1 : 0,
          numberOfApplicants: this.props.applicantData.length,
        });
      });
    }

    previousApplicant = () => {
      if (this.state.currentApplicant === 1) {
        browserHistory.push(`/companies/applications/${this.props.applicationID}`);
      } else {
        this.setState({ currentApplicant: this.state.currentApplicant - 1 });
      }
    };

    nextApplicant = () => {
      this.setState({ currentApplicant: this.state.currentApplicant + 1 });
    };

    render() {
      const style = {
        maxWidth: '650px',
        border: '1px solid #e1e1e1',
        boxShadow: 'none',
        padding: '15px',
        margin: 'auto',
      };

      const subMenuHeader = {
        backgroundColor: '#f7f7f7',
        margin: '20px -15px',
        textAlign: 'center',
        color: '#888888',
      };

      const deleteApplicationDocument = async documentId => {
        await this.props.deleteApplicationDocument(documentId);
        this.props.getApplication(this.props.applicationID);
      };

      const renderApplicants = this.props.applicantData.map(cotenant => (
        <div className="row" id="application_printable_area">
          <div
            className="row"
            style={{ textAlign: 'right', margin: '5px auto 10px', maxWidth: '650px' }}
          >
            <PrintButton
              printHeader="Application Details"
              printElementID={'application_printable_area'}
            />
          </div>
          <Paper style={style} zDepth={1}>
            <TenantInfo
              applicationID={this.props.applicationID}
              applicantData={cotenant.general_details}
              previousAddress={cotenant.previous_address}
              applied={cotenant.applied}
              leadId={cotenant.lead_id}
              sinNumber={cotenant.sin_number ? cotenant.sin_number : null}
              showCreditReport={this.props.application.can_view_credit_check}
              getApplication={() => this.props.getApplication(this.props.applicationID)}
              deleteTenantDocument={deleteApplicationDocument}
              landlordCountry={this.props.landlordCountry}
            />

            <ApplicantQuestions
              applicant_data={cotenant.application_questions}
              has_previously_rented={cotenant.has_previously_rented}
              sub_menu_header_styling={subMenuHeader}
            />

            <ApplicantPreviousAddress previousAddress={cotenant.previous_address} />

            <EmergencyContact emergencyContactDetails={cotenant.emergency_contacts} />

            <EmploymentInformation applicant_data={cotenant.employment_information} />

            <TenantPets pets={cotenant.pets} />

            <TenantVehicles vehicles={cotenant.vehicle_information} />

            <LandlordReference
              applicant_data={cotenant.landlord_information}
              applicantId={cotenant.lead_id}
              approveReference={this.approveReference}
              cotenantName={cotenant.full_name}
            />

            <PersonalReference
              applicant_data={cotenant.personal_references}
              applicantId={cotenant.lead_id}
              approveReference={this.approveReference}
            />

            <AdditionalOccupants additionalOccupants={this.props.additionalOccupants} />

            <ReviewTerms
              acceptedTerms={cotenant.general_details.application_terms_agreed}
              acceptedAtDate={cotenant.general_details.application_terms_agreed_date}
            />
          </Paper>
        </div>
      ));

      let nextButtonName;
      if (this.state.currentApplicant === this.state.numberOfApplicants) {
        nextButtonName = 'Create Lease';
      }

      return (
        <div className="body" role="main">
          <ChargeCardDialog
            isOpen={this.state.showChargeCard}
            chargeCard={this.chargeCard}
            submitting={this.state.submitting}
            toggleOpen={() => this.setState({ showChargeCard: !this.state.showChargeCard })}
          />
          <div className="centers contacts-ui">
            <div>
              <div className="stage-header clearfix">
                <span className="page-title">
                  <Link style={{ color: 'inherit' }} to="/companies/applications">
                    Applications
                  </Link>{' '}
                  {`> Review Applicants ${this.state.currentApplicant}/${this.state
                    .numberOfApplicants}`}
                </span>
              </div>

              {renderApplicants[this.state.currentApplicant - 1]}

              <div style={{ height: '150px' }} />
            </div>
          </div>
          <div className="form_sticky_footer_buttons">
            <FlatButton
              label="Back"
              type="button"
              className="previous"
              onClick={this.previousApplicant}
              backgroundColor="#fff"
              hoverColor="grey"
              style={{
                color: AccentColor(),
                float: 'left',
                height: '40px',
              }}
            />
            {!(nextButtonName && !this.state.creatingLease) && (
              <FlatButton
                label={'Next Applicant'}
                className="next"
                type="submit"
                primary={true}
                onClick={this.nextApplicant}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={{
                  color: 'white',
                  float: 'right',
                  height: '40px',
                }}
              />
            )}
          </div>
        </div>
      );
    }
  }
);
